import { fetchUsersSchema, fetchUsers, fetchUser } from '../api/users';

const state = {
    schema: {},
    users: [],
    user: {},
    selectedUsers: [],
};

const getters = {};

const mutations = {
    SET_USERS_SCHEMA(state, schema = {}) {
        state.schema = Object.freeze(schema);
    },
    SET_USERS(state, users) {
        state.users = Object.freeze(users);
    },
    SET_USER(state, user) {
        state.user = Object.freeze(user);
    },
    SET_SELECTED_USERS(state, users) {
        state.selectedUsers = users;
    },
};

const actions = {
    async fetchUsersSchema({ commit }) {
        commit('SET_USERS_SCHEMA', await fetchUsersSchema());
    },
    async fetchUsers({ commit }) {
        commit('SET_USERS', await fetchUsers());
    },
    async fetchUser({ commit }, { id }) {
        commit('SET_USER', await fetchUser(id));
    },
    async fetchData({ dispatch }) {
        await Promise.all([dispatch('fetchUsersSchema'), dispatch('fetchUsers')]);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
